module.exports = ".ck.ck-editor__editable .video{position:relative}.ck.ck-editor__editable .video .ck-progress-bar{position:absolute;top:0;left:0}"